<template>
  <b-form>
    <div class="row mb-3 border-bottom g-0">
      <div class="col-12">
        <span class="fw-bold">Form Penilaian Laporan Tahunan</span>
      </div>
    </div>
    <div class="row mb-3 border-bottom g-0">
      <div
        class="col-6 d-flex justify-content-between align-items-center pb-3"
        style="pointer-events: inherit !important"
      >
        <span>Laporan Tahunan Pemohon</span>
        <router-link
          class="btn btn-info"
          :to="`/app/laporan-tahunan/tinjau?id_laporan=${$route.query.id_laporan}`"
          target="_blank"
        >
          <i class="fa fa-eye" />
          Tinjau
        </router-link>
      </div>
    </div>
    <div :class="['row mb-3']">
      <div class="col-md-6">
        <label>Tanggal Penilaian <span class="text-danger">*</span></label>
        <DatePicker
          lang="en"
          id="tgl_penilaian"
          :placeholder="tgl_penilaian"
          input-class="form-control"
          name="Tanggal Penilaian"
          @change="
            (val) => {
              this.tgl_penilaian = val.toLocaleDateString('en-GB')
              this.form.tgl_penilaian = formatDate(val, 'YYYY-MM-DD')
              this.removeFormError('Tanggal Penilaian')
            }
          "
          :class="['w-100', { 'pe-none': sudah_dinilai }]"
        >
          <i class="fa fa-calendar-o" slot="calendar-icon" />
        </DatePicker>
        <span class="text-danger" v-if="errors.has('Tanggal Penilaian')">
          {{ errors.first('Tanggal Penilaian') }}
        </span>
      </div>
      <div class="col-md-6">
        <label>Penilai</label>
        <b-form-input
          v-model="form.tim_penilai"
          name="Penilai"
          id="tim_penilai"
          disabled
          style="background-color: #dddddd !important; opacity: 0.7"
        ></b-form-input>
      </div>
      <div class="col-md-6 mt-3">
        <label>Nomor KKPRL</label>
        <b-form-input
          v-model="form.nomor_kkprl"
          name="Nomor KKPRL"
          id="nomor_kkprl"
          disabled
          style="background-color: #dddddd !important; opacity: 0.7"
        ></b-form-input>
      </div>
      <div class="col-md-6 mt-3">
        <label>Alamat Kantor</label>
        <b-form-input
          v-model="form.alamat_kantor"
          name="Alamat Kantor"
          id="alamat_kantor"
          disabled
          style="background-color: #dddddd !important; opacity: 0.7"
        ></b-form-input>
      </div>
      <div class="col-md-6 mt-3">
        <label>Nomor Telepon/Faksimil</label>
        <b-form-input
          v-model="form.no_telepon"
          name="Nomor Telepon"
          id="no_telepon"
          disabled
          style="background-color: #dddddd !important; opacity: 0.7"
        ></b-form-input>
      </div>
      <div class="col-md-6 mt-3">
        <label>Surat Elektronik</label>
        <b-form-input
          v-model="form.surat_elektronik"
          name="Surat Elektronik"
          id="surat_elektronik"
          disabled
          style="background-color: #dddddd !important; opacity: 0.7"
        ></b-form-input>
      </div>
      <div class="col-md-6 mt-3">
        <label>Status Penanaman Modal</label>
        <v-select
          v-model="form.status_penanaman_modal"
          id="status_penanaman_modal"
          :reduce="(data) => data.value"
          label="text"
          :options="optionStatusPenanamanModal"
          name="Status Penanaman Modal"
          disabled
          style="background-color: #dddddd !important; opacity: 0.7"
        />
      </div>
      <div class="col-md-6 mt-3">
        <div class="row g-3">
          <div class="col-6">
            <label>Luas (ha)</label>
            <b-form-input
              v-model="form.luas"
              name="Luas"
              id="luas"
              disabled
              style="background-color: #dddddd !important; opacity: 0.7"
            ></b-form-input>
          </div>
          <div class="col-6">
            <label>Panjang (km)</label>
            <b-form-input
              v-model="form.panjang"
              name="Panjang"
              id="panjang"
              disabled
              style="background-color: #dddddd !important; opacity: 0.7"
            ></b-form-input>
          </div>
        </div>
      </div>
      <div class="col-md-6 mt-3">
        <label>Lokasi</label>
        <v-select
          v-model="form.lokasi"
          id="lokasi"
          :reduce="(data) => data.nama_provinsi"
          label="text"
          :options="dataProvinsi"
          multiple
          name="Lokasi"
          disabled
          style="background-color: #dddddd !important; opacity: 0.7"
        />
      </div>
      <div class="col-md-6 mt-3">
        <label>Nama Perairan</label>
        <b-form-textarea
          name="Nama Perairan"
          v-model="form.nama_perairan"
          id="nama_perairan"
          rows="3"
          disabled
          style="background-color: #dddddd !important; opacity: 0.7"
        ></b-form-textarea>
      </div>
      <div class="col-md-6 mt-3">
        <label>Tanggal Penerbitan KKPRL</label>
        <b-form-input
          v-model="form.tgl_penerbitan_kkprl"
          name="Tanggal Penerbitan KKPRL"
          id="tgl_penerbitan_kkprl"
          disabled
          style="background-color: #dddddd !important; opacity: 0.7"
        ></b-form-input>
      </div>
      <div class="col-md-6 mt-3">
        <label>Tanggal disampaikan laporan tahunan</label>
        <b-form-input
          v-model="form.tgl_disampaikan_laporan_tahunan"
          name="Tanggal disampaikan laporan tahunan"
          id="tgl_disampaikan_laporan_tahunan"
          disabled
          style="background-color: #dddddd !important; opacity: 0.7"
        ></b-form-input>
      </div>
    </div>

    <div class="mb-3 border-bottom"></div>
    <div style="background-color: white">
      <div class="row border-bottom g-0 p-1">
        <div class="col-8">
          <div class="row g-0">
            <div class="col-1 fw-bold text-center">No</div>
            <div class="col-9 fw-bold">Indikator</div>
            <div class="col-2 fw-bold">Skor</div>
          </div>
        </div>
        <div class="col-4"><span class="fw-bold">Keterangan</span></div>
      </div>
      <div class="row border-bottom g-0 p-1">
        <div class="col-8">
          <div class="row g-0">
            <div class="col-1 fw-bold text-center">1</div>
            <div class="col-9 fw-bold">Identitas Pemegang KKPRL</div>
          </div>
        </div>
      </div>
      <div class="row border-bottom g-0 p-1">
        <div :class="['col-8', { 'pe-none': sudah_dinilai }]">
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="identitas_pemegang_kkprl_nomor" class="flex-grow-1">Nomor</label>
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.identitas_pemegang_kkprl.nomor"
                  id="identitas_pemegang_kkprl_nomor"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.identitas_pemegang_kkprl.nomor">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="identitas_pemegang_kkprl_tgl_penerbitan" class="flex-grow-1">tanggal penerbitan</label>
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.identitas_pemegang_kkprl.tgl_penerbitan"
                  id="identitas_pemegang_kkprl_tgl_penerbitan"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.identitas_pemegang_kkprl.tgl_penerbitan">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="identitas_pemegang_kkprl_nama_pemegang" class="flex-grow-1">nama pemegang</label>
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.identitas_pemegang_kkprl.nama_pemegang"
                  id="identitas_pemegang_kkprl_nama_pemegang"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.identitas_pemegang_kkprl.nama_pemegang">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="identitas_pemegang_kkprl_npwp" class="flex-grow-1">NPWP</label>
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.identitas_pemegang_kkprl.npwp"
                  id="identitas_pemegang_kkprl_npwp"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.identitas_pemegang_kkprl.npwp">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="identitas_pemegang_kkprl_alamat_kantor" class="flex-grow-1">alamat kantor</label>
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.identitas_pemegang_kkprl.alamat_kantor"
                  id="identitas_pemegang_kkprl_alamat_kantor"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.identitas_pemegang_kkprl.alamat_kantor">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="identitas_pemegang_kkprl_no_telepon" class="flex-grow-1">nomor telepon/faksimili</label>
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.identitas_pemegang_kkprl.no_telepon"
                  id="identitas_pemegang_kkprl_no_telepon"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.identitas_pemegang_kkprl.no_telepon">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="identitas_pemegang_kkprl_surat_elektronik" class="flex-grow-1">surat elektronik</label>
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.identitas_pemegang_kkprl.surat_elektronik"
                  id="identitas_pemegang_kkprl_surat_elektronik"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.identitas_pemegang_kkprl.surat_elektronik">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="identitas_pemegang_kkprl_status_penanaman_modal" class="flex-grow-1"
                >status penanaman modal</label
              >
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.identitas_pemegang_kkprl.status_penanaman_modal"
                  id="identitas_pemegang_kkprl_status_penanaman_modal"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.identitas_pemegang_kkprl.status_penanaman_modal">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <b-form-textarea
            v-model="form.identitas_pemegang_kkprl.keterangan"
            id="identitas_pemegang_kkprl_keterangan"
            name="textarea"
            :rows="5"
            disabled
          ></b-form-textarea>
        </div>
      </div>

      <div class="row border-bottom g-0 p-1">
        <div class="col-8">
          <div class="row g-0">
            <div class="col-1 fw-bold text-center">2</div>
            <div class="col-9 fw-bold">Identitas penanggung jawab</div>
          </div>
        </div>
      </div>
      <div class="row border-bottom g-0 p-1">
        <div :class="['col-8', { 'pe-none': sudah_dinilai }]">
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="nama_penanggung_jawab" class="flex-grow-1">Nama penanggung jawab</label>
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.identitas_penanggung_jawab.nama_penanggung_jawab"
                  id="nama_penanggung_jawab"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.identitas_penanggung_jawab.nama_penanggung_jawab">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="jabatan_penanggung_jawab" class="flex-grow-1">Jabatan penanggung jawab</label>
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.identitas_penanggung_jawab.jabatan_penanggung_jawab"
                  id="jabatan_penanggung_jawab"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.identitas_penanggung_jawab.jabatan_penanggung_jawab">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="no_telepon_penanggung_jawab" class="flex-grow-1">Nomor telepon</label>
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.identitas_penanggung_jawab.nomor_telepon"
                  id="no_telepon_penanggung_jawab"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.identitas_penanggung_jawab.nomor_telepon">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="surat_elektronik_penanggung_jawab" class="flex-grow-1">Surat Elektronik</label>
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.identitas_penanggung_jawab.surat_elektronik"
                  id="surat_elektronik_penanggung_jawab"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.identitas_penanggung_jawab.surat_elektronik">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <b-form-textarea
            v-model="form.identitas_penanggung_jawab.keterangan"
            id="keterangan_penanggung_jawab"
            name="textarea"
            :rows="5"
            disabled
          ></b-form-textarea>
        </div>
      </div>

      <div class="row border-bottom g-0 p-1">
        <div class="col-8">
          <div class="row g-0">
            <div class="col-1 fw-bold text-center">3</div>
            <div class="col-9 fw-bold">Kemajuan perizinan yang diperoleh</div>
          </div>
        </div>
      </div>
      <div class="row border-bottom g-0 p-1">
        <div :class="['col-8', { 'pe-none': sudah_dinilai }]">
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="status_persetujuan_lingkungan_2" class="flex-grow-1"
                >Belum menyampaikan/melampirkan persetujuan lingkungan</label
              >
            </div>
            <div class="col-2">
              <div class="form-check ms-2">
                <input
                  v-model="form.kemajuan_perizinan_yang_diperoleh.status_persetujuan_lingkungan"
                  value="0"
                  id="status_persetujuan_lingkungan_2"
                  v-validate="'required'"
                  class="form-check-input"
                  type="radio"
                  name="Kemajuan Persetujuan Lingkungan"
                />
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="status_persetujuan_lingkungan_1" class="flex-grow-1"
                >Sedang mengurus persetujuan lingkungan</label
              >
            </div>
            <div class="col-2">
              <div class="form-check ms-2">
                <input
                  v-model="form.kemajuan_perizinan_yang_diperoleh.status_persetujuan_lingkungan"
                  value="2"
                  id="status_persetujuan_lingkungan_1"
                  v-validate="'required'"
                  class="form-check-input"
                  type="radio"
                  name="Kemajuan Persetujuan Lingkungan"
                />
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="status_persetujuan_lingkungan_2" class="flex-grow-1"
                >Persetujuan lingkungan telah terbit</label
              >
            </div>
            <div class="col-2">
              <div class="form-check ms-2">
                <input
                  v-model="form.kemajuan_perizinan_yang_diperoleh.status_persetujuan_lingkungan"
                  value="5"
                  id="status_persetujuan_lingkungan_2"
                  v-validate="'required'"
                  class="form-check-input"
                  type="radio"
                  name="Kemajuan Persetujuan Lingkungan"
                />
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end my-1 border-bottom">
            <div class="col-9 d-flex">
              <label for="bukti_sedang_mengurus_persetujuan_lingkungan" class="flex-grow-1"
                >*) apabila disampaikan bukti sedang mengurus/dokumen telah terbit</label
              >
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.kemajuan_perizinan_yang_diperoleh.bukti_sedang_mengurus_persetujuan_lingkungan"
                  id="bukti_sedang_mengurus_persetujuan_lingkungan"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.kemajuan_perizinan_yang_diperoleh.bukti_sedang_mengurus_persetujuan_lingkungan"
                  >Ada</span
                >
                <span v-else>Tidak Ada</span>
              </div>
            </div>
            <div class="col-11">
              <span class="text-danger" v-if="errors.has('Kemajuan Persetujuan Lingkungan')">
                {{ errors.first('Kemajuan Persetujuan Lingkungan') }}
              </span>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="status_perizinan_berusaha_nonberusaha_2" class="flex-grow-1"
                >Belum menyampaikan/melampirkan perizinan {{ jenis_kegiatan?.toLowerCase() }}</label
              >
            </div>
            <div class="col-2">
              <div class="form-check ms-2">
                <input
                  v-model="form.kemajuan_perizinan_yang_diperoleh.status_perizinan_berusaha_nonberusaha"
                  value="0"
                  id="status_perizinan_berusaha_nonberusaha_2"
                  v-validate="'required'"
                  class="form-check-input"
                  type="radio"
                  name="Kemajuan Perizinan Berusaha"
                />
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="status_perizinan_berusaha_nonberusaha_1" class="flex-grow-1"
                >Sedang mengurus perizinan {{ jenis_kegiatan?.toLowerCase() }}</label
              >
            </div>
            <div class="col-2">
              <div class="form-check ms-2">
                <input
                  v-model="form.kemajuan_perizinan_yang_diperoleh.status_perizinan_berusaha_nonberusaha"
                  value="2"
                  id="status_perizinan_berusaha_nonberusaha_1"
                  v-validate="'required'"
                  class="form-check-input"
                  type="radio"
                  name="Kemajuan Perizinan Berusaha"
                />
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="status_perizinan_berusaha_nonberusaha_2" class="flex-grow-1"
                >Perizinan {{ jenis_kegiatan?.toLowerCase() }} telah terbit</label
              >
            </div>
            <div class="col-2">
              <div class="form-check ms-2">
                <input
                  v-model="form.kemajuan_perizinan_yang_diperoleh.status_perizinan_berusaha_nonberusaha"
                  value="5"
                  id="status_perizinan_berusaha_nonberusaha_2"
                  v-validate="'required'"
                  class="form-check-input"
                  type="radio"
                  name="Kemajuan Perizinan Berusaha"
                />
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="bukti_sedang_mengurus_perizinan_berusaha_nonberusaha" class="flex-grow-1"
                >*) apabila disampaikan bukti sedang mengurus/dokumen telah terbit</label
              >
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.kemajuan_perizinan_yang_diperoleh.bukti_sedang_mengurus_perizinan_berusaha_nonberusaha"
                  id="bukti_sedang_mengurus_perizinan_berusaha_nonberusaha"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.kemajuan_perizinan_yang_diperoleh.bukti_sedang_mengurus_perizinan_berusaha_nonberusaha"
                  >Ada</span
                >
                <span v-else>Tidak Ada</span>
              </div>
            </div>
            <div class="col-11">
              <span class="text-danger" v-if="errors.has('Kemajuan Perizinan Berusaha')">
                {{ errors.first('Kemajuan Perizinan Berusaha') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-4">
          <b-form-textarea
            v-model="form.kemajuan_perizinan_yang_diperoleh.keterangan"
            id="kemajuan_perizinan_keterangan"
            name="textarea"
            :rows="3"
            disabled
          ></b-form-textarea>
        </div>
      </div>

      <div class="row border-bottom g-0 p-1">
        <div class="col-8">
          <div class="row g-0">
            <div class="col-1 fw-bold text-center">4</div>
            <div class="col-9 fw-bold">Realisasi pemanfaatan Ruang Laut</div>
          </div>
        </div>
      </div>
      <div class="row border-bottom g-0 p-1">
        <div :class="['col-8', { 'pe-none': sudah_dinilai }]">
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="realisasi_pemanfaatan_ruang_laut_luas_panjang" class="flex-grow-1">Luas/panjang</label>
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.realisasi_pemanfaatan_ruang_laut.luas_panjang"
                  id="realisasi_pemanfaatan_ruang_laut_luas_panjang"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.realisasi_pemanfaatan_ruang_laut.luas_panjang">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="realisasi_pemanfaatan_ruang_laut_lokasi_kegiatan" class="flex-grow-1">Lokasi kegiatan</label>
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.realisasi_pemanfaatan_ruang_laut.lokasi_kegiatan"
                  id="realisasi_pemanfaatan_ruang_laut_lokasi_kegiatan"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.realisasi_pemanfaatan_ruang_laut.lokasi_kegiatan">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div
            v-if="jenis_kegiatan === 'Berusaha'"
            :class="[
              'row g-0 d-flex justify-content-end mt-1',
              {
                'pe-none opacity-50': this.jenis_kegiatan === 'Non Berusaha',
              },
            ]"
          >
            <div class="col-9 d-flex">
              <label for="realisasi_pemanfaatan_ruang_laut_kode_kbli" class="flex-grow-1">Kode KBLI</label>
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.realisasi_pemanfaatan_ruang_laut.kode_kbli"
                  id="realisasi_pemanfaatan_ruang_laut_kode_kbli"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.realisasi_pemanfaatan_ruang_laut.kode_kbli">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="realisasi_pemanfaatan_ruang_laut_kegiatan" class="flex-grow-1"
                >Kegiatan {{ jenis_kegiatan?.toLowerCase() }}</label
              >
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.realisasi_pemanfaatan_ruang_laut.kegiatan"
                  id="realisasi_pemanfaatan_ruang_laut_kegiatan"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.realisasi_pemanfaatan_ruang_laut.kegiatan">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="realisasi_pemanfaatan_ruang_laut_detail_kegiatan" class="flex-grow-1"
                >Detail kegiatan {{ jenis_kegiatan?.toLowerCase() }}</label
              >
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.realisasi_pemanfaatan_ruang_laut.detail_kegiatan"
                  id="realisasi_pemanfaatan_ruang_laut_detail_kegiatan"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.realisasi_pemanfaatan_ruang_laut.detail_kegiatan">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="realisasi_pemanfaatan_ruang_laut_dokumentasi_kegiatan" class="flex-grow-1"
                >Dokumentasi kegiatan bangunan/instalasi di lokasi</label
              >
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.realisasi_pemanfaatan_ruang_laut.dokumentasi_kegiatan"
                  id="realisasi_pemanfaatan_ruang_laut_dokumentasi_kegiatan"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.realisasi_pemanfaatan_ruang_laut.dokumentasi_kegiatan">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
          <div class="row g-0 d-flex justify-content-end mt-1">
            <div class="col-9 d-flex">
              <label for="realisasi_pemanfaatan_ruang_laut_waktu_realisasi_kegiatan" class="flex-grow-1"
                >Waktu realisasi kegiatan</label
              >
            </div>
            <div class="col-2">
              <div class="form-check form-switch">
                <input
                  v-model="form.realisasi_pemanfaatan_ruang_laut.waktu_realisasi_kegiatan"
                  id="realisasi_pemanfaatan_ruang_laut_waktu_realisasi_kegiatan"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                />
                <span v-if="form.realisasi_pemanfaatan_ruang_laut.waktu_realisasi_kegiatan">Ada</span>
                <span v-else>Tidak Ada</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <b-form-textarea
            v-model="form.realisasi_pemanfaatan_ruang_laut.keterangan"
            id="realisasi_pemanfaatan_ruang_laut_keterangan"
            name="textarea"
            :rows="5"
            disabled
          ></b-form-textarea>
        </div>
      </div>

      <div class="row border-bottom g-0 p-1">
        <div class="col-8">
          <div class="row g-0">
            <div class="col-1 fw-bold text-center">5</div>
            <div class="col-9">Pemenuhan kewajiban</div>
          </div>
        </div>
      </div>

      <div v-for="(data, index) in title_pemenuhan_kewajiban" :key="index">
        <PemenuhanKewajiban
          ref="form"
          :titletmp="data"
          :formtmp="form.pemenuhan_kewajiban[index]"
          :sudah_dinilai="sudah_dinilai"
          @form="updateForm($event, index)"
        />
      </div>

      <div class="d-flex">
        <div class="row mx-auto my-3 gy-1 align-items-center" style="width: 400px">
          <div class="col-6 fw-bold">Total Skor</div>
          <div class="col-6">
            <b-form-input v-model="form.total_skor" v-validate="'required'" name="total_skor" disabled></b-form-input>
          </div>
          <div class="col-6 fw-bold">Nilai</div>
          <div class="col-6">
            <b-form-input v-model="form.nilai" v-validate="'required'" name="nilai" disabled></b-form-input>
          </div>
          <div class="col-6 fw-bold">Kategori</div>
          <div class="col-6">
            <b-form-input v-model="form.kategori" v-validate="'required'" name="kategori" disabled></b-form-input>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-2 border-bottom pb-5"></div>
    <div :class="['row', { 'pe-none': sudah_dinilai }]">
      <div class="col-lg-6">
        <label>Status Penyampaian</label>
        <b-form-input
          v-model="form.status_penyampaian"
          id="status_penyampaian"
          v-validate="'required'"
          name="Status Penyampaian"
          :class="form.status_penyampaian === 'Telat' ? 'text-danger is-invalid' : ''"
          disabled
        ></b-form-input>
        <div v-if="form.jumlah_hari_keterlambatan" class="mt-3">
          <label>Jumlah hari keterlambatan</label>
          <div class="input-units">
            <b-form-input
              v-model="form.jumlah_hari_keterlambatan"
              id="jumlah_hari_keterlambatan"
              v-validate="'required'"
              name="Jumlah Hari Keterlambatan"
              class="text-danger is-invalid"
              disabled
            ></b-form-input>
            <div class="text-units text-danger">
              <span>{{ form.jumlah_hari_keterlambatan }}</span>
              <span> hari</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div>
          <label>Masa Berlaku <span class="text-danger">*</span></label>
          <v-select
            v-model="jenis_masa_berlaku"
            id="masa_berlaku"
            :reduce="(data) => data.value"
            label="text"
            :options="[
              { value: 'Diketahui', text: 'Diketahui', },
              { value: 'Selama Menjalankan Kegiatan Usaha', text: 'Selama Menjalankan Kegiatan Usaha', },
            ]"
            name="Jenis Masa Berlaku"
            v-validate="'required'"
          />
        </div>
        <div v-if="jenis_masa_berlaku === 'Diketahui'" class="mt-2">
          <b-form-input
            type="date"
            v-model="form.masa_berlaku"
            id="masa_berlaku"
            v-validate="'required'"
            name="Masa Berlaku"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('Masa Berlaku')">
            {{ errors.first('Masa Berlaku') }}
          </span>
        </div>
        <div class="mt-3">
          <label for="rekomendasi_penilaian_kkprl">Rekomendasi Penilaian KKPRL</label>
          <v-select
            id="rekomendasi_penilaian_kkprl"
            v-model="form.rekomendasi_penilaian_kkprl"
            :options="['Ya', 'Tidak']"
            name="Rekomendasi Penilaian KKPRL"
          />
        </div>
        <!-- <div class="mt-3">
          <label for="nomor_berita_acara">Nomor Berita Acara</label>
          <b-form-input
            v-model="form.nomor_berita_acara"
            id="nomor_berita_acara"
            v-validate="'required'"
            name="Nomor Berita Acara"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('Nomor Berita Acara')">
            {{ errors.first('Nomor Berita Acara') }}
          </span>
        </div> -->
        <!-- <div v-if="form.total_skor >= 66" class="mt-3">
          <label for="nomor_sertifikat">Nomor Sertifikat</label>
          <b-form-input
            v-model="form.nomor_sertifikat"
            id="nomor_sertifikat"
            v-validate="'required'"
            name="Nomor Sertifikat"
          ></b-form-input>
          <span class="text-danger" v-if="errors.has('Nomor Sertifikat')">
            {{ errors.first('Nomor Sertifikat') }}
          </span>
        </div> -->
      </div>
    </div>
    <div :class="['mt-3', { 'pe-none': sudah_dinilai }]">
      <label>Catatan</label>
      <ckeditor :editor="wygEditor" v-model="form.catatan"></ckeditor>
    </div>
    <div class="mt-3 text-right">
      <b-button style="background-color: #ff6d1f" class="text-white" @click="toggleModalChat">
        <i class="bi bi-chat"></i> Diskusi
      </b-button>
      <b-button v-if="!sudah_dinilai" variant="secondary" class="ms-2" @click="saveAsDraft">
        Simpan Draf <i class="fa fa-file-o" />
      </b-button>
    </div>
    <div class="mt-5 fw-bold">Note: tanda (<span class="text-danger">*</span>) wajib diisi</div>

    <ModalChat :data-laporan="selectedLaporan" />
  </b-form>
</template>

<style scoped>
:deep(.col-2:has(.form-check)) {
  display: flex;
}

:deep(.form-check) {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

:deep(.fa-circle) {
  font-size: 0.4rem !important;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 0.5rem;
  margin-left: 2rem;
}

:deep(.vs__dropdown-toggle) {
  --vs-disabled-bg: #dddddd;
  --vs-disabled-cursor: default;
}
</style>

<script>
import vSelect from 'vue-select'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import DatePicker from 'vue2-datepicker'
import axios from 'axios'
import { formatDate, getUrlFilename, downloadFile } from '../../helper/helpernew'
import PemenuhanKewajiban from './Components/PemenuhanKewajiban.vue'
import Vue from 'vue'
import { integerMask } from '../../helper/validationHelper'
import Swal from 'sweetalert2'
import ModalChat from '../../components/ModalChat/ModalChat.vue'
import dayjs from 'dayjs'

export default {
  components: {
    vSelect,
    DatePicker,
    PemenuhanKewajiban,
    ModalChat,
  },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      id_penilaian: null,
      selectedLaporan: null,
      form: {
        tgl_penilaian: null,
        tim_penilai: null,
        nomor_kkprl: null,
        alamat_kantor: null,
        no_telepon: null,
        surat_elektronik: null,
        status_penanaman_modal: null,
        luas: null,
        panjang: null,
        lokasi: null,
        nama_perairan: null,
        tgl_penerbitan_kkprl: null,
        tgl_disampaikan_laporan_tahunan: null,
        identitas_pemegang_kkprl: {
          nomor: false,
          tgl_penerbitan: false,
          nama_pemegang: false,
          npwp: false,
          alamat_kantor: false,
          no_telepon: false,
          surat_elektronik: false,
          status_penanaman_modal: false,
          keterangan: null,
        },
        identitas_penanggung_jawab: {
          nama_penanggung_jawab: false,
          jabatan_penanggung_jawab: false,
          nomor_telepon: false,
          surat_elektronik: false,
          keterangan: null,
        },
        kemajuan_perizinan_yang_diperoleh: {
          status_persetujuan_lingkungan: null,
          bukti_sedang_mengurus_persetujuan_lingkungan: false,
          status_perizinan_berusaha_nonberusaha: null,
          bukti_sedang_mengurus_perizinan_berusaha_nonberusaha: false,
          keterangan: null,
        },
        realisasi_pemanfaatan_ruang_laut: {
          luas_panjang: false,
          lokasi_kegiatan: false,
          kode_kbli: false,
          kegiatan: false,
          detail_kegiatan: false,
          dokumentasi_kegiatan: false,
          waktu_realisasi_kegiatan: false,
          keterangan: null,
        },
        pemenuhan_kewajiban: [],
        total_identitas_pemegang_kkprl: 0,
        total_identitas_penanggung_jawab: 0,
        total_kemajuan_perizinan_yang_diperoleh: 0,
        total_realisasi_pemanfaatan_ruang_laut: 0,
        total_pemenuhan_kewajiban: 0,
        total_skor: 0,
        nilai: '-',
        kategori: '-',
        status_penyampaian: null,
        jumlah_hari_keterlambatan: null,
        masa_berlaku: '',
        rekomendasi_penilaian_kkprl: null,
        // nomor_berita_acara: '',
        // nomor_sertifikat: '',
        catatan: '',
      },
      jenis_kegiatan: null,
      sudah_dinilai: null,
      tgl_penilaian: 'dd/mm/yyyy',
      optionStatusPenanamanModal: [
        {
          value: 'Penanaman Modal Dalam Negeri (PMDN)',
          text: 'Penanaman Modal Dalam Negeri (PMDN)',
        },
        {
          value: 'Penanaman Modal Asing (PMA)',
          text: 'Penanaman Modal Asing (PMA)',
        },
      ],
      dataProvinsi: [],
      wygEditor: ClassicEditor,
      jenis_masa_berlaku: 'Diketahui',
    }
  },
  computed: {
    title_pemenuhan_kewajiban() {
      return [
        '1) memperhatikan keberlanjutan kehidupan dan penghidupan Masyarakat',
        '2) memberikan akses untuk nelayan kecil yang sudah secara rutin melintas',
        '3) menghormati kepentingan pihak lain yang melakukan kegiatan atau Pemanfaatan Ruang di sekitarnya',
        '4) melakukan kegiatan secara ramah lingkungan',
        '5) menjaga kelestarian ekosistem Laut dan melakukan rehabilitasi sumber daya yang mengalami kerusakan',
        '6) menjaga kehidupan dan alur migrasi biota Laut',
        '7) memberikan akses/tempat berlindung kepada siapapun dalam kondisi darurat',
        '8) melibatkan dan memberdayakan Masyarakat sekitar lokasi kegiatan/usaha',
        '9) membongkar Bangunan dan Instalasi di Laut apabila masa berlaku telah habis dan kegiatan/usaha tidak dilanjutkan lagi',
        '10) tidak menimbulkan konflik',
        '11) tidak menimbulkan gangguan bagi pelaksanaan kepentingan keselamatan, pertahanan keamanan, dan memperhatikan kepentingan nasional',
        '12) menyampaikan laporan perolehan Perizinan ' + this.jenis_kegiatan,
        '13) menyampaikan laporan secara tertulis setiap 1 (satu) tahun kepada Menteri',
        '14) bermitra dengan pengelola Kawasan Konservasi di Laut dalam rangka program kemitraan dan bina lingkungan dalam hal lokasi kegiatan berada dalam Kawasan Konservasi di Laut',
        '15) melaporkan pendirian dan/atau penempatan Bangunan dan Instalasi di Laut kepada instansi yang menyelenggarakan urusan pemerintahan di bidang hidrografi dan oseanografi',
        '16) menyediakan prasarana dan sarana pencegahan pencemaran dan pencegahan kerusakan sumber daya ikan serta lingkungannya',
      ]
    },
  },
  created() {
    for (let i = 0; i < this.title_pemenuhan_kewajiban.length; i++) {
      this.form.pemenuhan_kewajiban.push({})
    }
  },
  mounted() {
    this.loadDataLaporanTahunan()
    this.loadDataPenilaian()
  },
  methods: {
    formatDate,
    getUrlFilename,
    downloadFile,
    integerMask,

    async nextForm() {
      if (this.sudah_dinilai) {
        return true
      }

      let validate = true
      if (this.form.tgl_penilaian === null) {
        this.addFormError('Tanggal Penilaian')
        validate = false
      }

      for (let i = 0; i < this.$refs.form.length; i++) {
        if ((await this.$refs.form[i].nextForm()) === false) {
          validate = false
        }
      }

      if ((await this.$validator.validateAll()) && validate) {
        this.$loading(true)
        // prettier-ignore
        const dataPenilaian = {
          id_laporan: parseInt(this.$route.query.id_laporan),
          tanggal_penilaian: this.form.tgl_penilaian,
          nomor_1: this.form.identitas_pemegang_kkprl.nomor,
          tanggal_penerbitan_1: this.form.identitas_pemegang_kkprl.tgl_penerbitan,
          nama_pemegang_1: this.form.identitas_pemegang_kkprl.nama_pemegang,
          npwp_1: this.form.identitas_pemegang_kkprl.npwp,
          alamat_kantor_1: this.form.identitas_pemegang_kkprl.alamat_kantor,
          no_telepon_1: this.form.identitas_pemegang_kkprl.no_telepon,
          email_1: this.form.identitas_pemegang_kkprl.surat_elektronik,
          status_penanaman_modal_1: this.form.identitas_pemegang_kkprl.status_penanaman_modal,
          keterangan_1: this.form.identitas_pemegang_kkprl.keterangan,
          nama_2: this.form.identitas_penanggung_jawab.nama_penanggung_jawab,
          jabatan_2: this.form.identitas_penanggung_jawab.jabatan_penanggung_jawab,
          no_telepon_2: this.form.identitas_penanggung_jawab.nomor_telepon,
          email_2: this.form.identitas_penanggung_jawab.surat_elektronik,
          keterangan_2: this.form.identitas_penanggung_jawab.keterangan,
          status_perizinan_lingkungan_3: this.form.kemajuan_perizinan_yang_diperoleh.status_persetujuan_lingkungan,
          bukti_mengurus_perizinan_lingkungan_3: this.form.kemajuan_perizinan_yang_diperoleh.bukti_sedang_mengurus_persetujuan_lingkungan,
          status_perizinan_berusaha_nonberusaha_3: this.form.kemajuan_perizinan_yang_diperoleh.status_perizinan_berusaha_nonberusaha,
          bukti_mengurus_perizinan_berusaha_nonberusaha_3: this.form.kemajuan_perizinan_yang_diperoleh.bukti_sedang_mengurus_perizinan_berusaha_nonberusaha,
          keterangan_3: this.form.kemajuan_perizinan_yang_diperoleh.keterangan,
          luas_panjang_4: this.form.realisasi_pemanfaatan_ruang_laut.luas_panjang,
          lokasi_kegiatan_4: this.form.realisasi_pemanfaatan_ruang_laut.lokasi_kegiatan,
          kode_kbli_4: this.form.realisasi_pemanfaatan_ruang_laut.kode_kbli,
          kegiatan_4: this.form.realisasi_pemanfaatan_ruang_laut.kegiatan,
          detail_kegiatan_4: this.form.realisasi_pemanfaatan_ruang_laut.detail_kegiatan,
          dokumentasi_kegiatan_4: this.form.realisasi_pemanfaatan_ruang_laut.dokumentasi_kegiatan,
          waktu_kegiatan_4: this.form.realisasi_pemanfaatan_ruang_laut.waktu_realisasi_kegiatan,
          keterangan_4: this.form.realisasi_pemanfaatan_ruang_laut.keterangan,
          keberlanjutan_kehidupan_5: this.form.pemenuhan_kewajiban[0].nilai,
          keterangan_keberlanjutan_kehidupan_5: this.form.pemenuhan_kewajiban[0].keterangan,
          akses_nelayan_5: this.form.pemenuhan_kewajiban[1].nilai,
          keterangan_akses_nelayan_5: this.form.pemenuhan_kewajiban[1].keterangan,
          kepentingan_5: this.form.pemenuhan_kewajiban[2].nilai,
          keterangan_kepentingan_5: this.form.pemenuhan_kewajiban[2].keterangan,
          ramah_lingkungan_5: this.form.pemenuhan_kewajiban[3].nilai,
          keterangan_ramah_lingkungan_5: this.form.pemenuhan_kewajiban[3].keterangan,
          kelestarian_5: this.form.pemenuhan_kewajiban[4].nilai,
          keterangan_kelestarian_5: this.form.pemenuhan_kewajiban[4].keterangan,
          kehidupan_migrasi_5: this.form.pemenuhan_kewajiban[5].nilai,
          keterangan_kehidupan_migrasi_5: this.form.pemenuhan_kewajiban[5].keterangan,
          akses_darurat_5: this.form.pemenuhan_kewajiban[6].nilai,
          keterangan_akses_darurat_5: this.form.pemenuhan_kewajiban[6].keterangan,
          memberdayakan_masyarakat_5: this.form.pemenuhan_kewajiban[7].nilai,
          keterangan_memberdayakan_masyarakat_5: this.form.pemenuhan_kewajiban[7].keterangan,
          membongkar_5: this.form.pemenuhan_kewajiban[8].nilai,
          keterangan_membongkar_5: this.form.pemenuhan_kewajiban[8].keterangan,
          tidak_konflik_5: this.form.pemenuhan_kewajiban[9].nilai,
          keterangan_tidak_konflik_5: this.form.pemenuhan_kewajiban[9].keterangan,
          tidak_ganggu_5: this.form.pemenuhan_kewajiban[10].nilai,
          keterangan_tidak_ganggu_5: this.form.pemenuhan_kewajiban[10].keterangan,
          laporan_perolehan_5: this.form.pemenuhan_kewajiban[11].nilai,
          keterangan_laporan_perolehan_5: this.form.pemenuhan_kewajiban[11].keterangan,
          laporan_rutin_5: this.form.pemenuhan_kewajiban[12].nilai,
          keterangan_laporan_rutin_5: this.form.pemenuhan_kewajiban[12].keterangan,
          bermitra_5: this.form.pemenuhan_kewajiban[13].nilai,
          keterangan_bermitra_5: this.form.pemenuhan_kewajiban[13].keterangan,
          melaporkan_hidrografi_oseanografi_5: this.form.pemenuhan_kewajiban[14].nilai,
          keterangan_melaporkan_hidrografi_oseanografi_5: this.form.pemenuhan_kewajiban[14].keterangan,
          sarana_prasarana_5: this.form.pemenuhan_kewajiban[15].nilai,
          keterangan_sarana_prasarana_5: this.form.pemenuhan_kewajiban[15].keterangan,
          total_identitas_pemegang_kkprl:this.form.total_identitas_pemegang_kkprl,
          total_identitas_penanggung_jawab:this.form.total_identitas_penanggung_jawab,
          total_kemajuan_perizinan_yang_diperoleh:this.form.total_kemajuan_perizinan_yang_diperoleh,
          total_realisasi_pemanfaatan_ruang_laut:this.form.total_realisasi_pemanfaatan_ruang_laut,
          total_pemenuhan_kewajiban:this.form.total_pemenuhan_kewajiban,
          total_skor: this.form.total_skor,
          nilai: this.form.nilai,
          kategori: this.form.kategori,
          status_penyampaian: this.form.status_penyampaian,
          jumlah_hari_keterlambatan: this.form.status_penyampaian === 'Telat' ? parseFloat(this.form.jumlah_hari_keterlambatan) : undefined,
          rekomendasi_penilaian_kkprl: this.form.rekomendasi_penilaian_kkprl,
          catatan: this.form.catatan,
        }

        if (this.jenis_masa_berlaku === 'Diketahui') {
          dataPenilaian.masa_berlaku = this.form.masa_berlaku
        } else {
          dataPenilaian.masa_berlaku = null
        }

        if (!this.$route.query.id_penilaian) {
          // create penilaian
          return axios
            .post(this.baseapiPengendalian + 'api/penilaian_laporan', dataPenilaian, this.getApiOption())
            .then((res) => {
              Swal.fire('Berhasil', 'Penilaian Laporan Tahunan tersimpan', 'success')
              this.$router.replace({
                path: this.$route.path,
                query: {
                  id_laporan: this.$route.query.id_laporan,
                  id_penilaian: res.data.data.id,
                },
              })
              return true
            })
            .catch((err) => {
              Swal.fire('Gagal', 'Terjadi kesalahan', 'error')
              return false
            })
            .finally(() => {
              this.$loading(false)
            })
        } else {
          // update penilaian
          dataPenilaian.id_laporan = undefined
          return axios
            .put(
              this.baseapiPengendalian + `api/penilaian_laporan/${this.$route.query.id_penilaian}`,
              dataPenilaian,
              this.getApiOption(),
            )
            .then((res) => {
              Swal.fire('Berhasil', 'Penilaian Laporan Tahunan tersimpan', 'success')
              return true
            })
            .catch((err) => {
              Swal.fire('Gagal', 'Terjadi kesalahan', 'error')
              return false
            })
            .finally(() => {
              this.$loading(false)
            })
        }
      } else {
        Swal.fire('', 'Pastikan semua form diisi', 'warning')
        return false
      }
    },

    updateForm(val, index) {
      Vue.set(this.form.pemenuhan_kewajiban, index, val)
    },

    async saveAsDraft() {
      this.$loading(true)
      // prettier-ignore
      const dataPenilaian = {
          id_laporan: parseInt(this.$route.query.id_laporan),
          tanggal_penilaian: this.form.tgl_penilaian,
          nomor_1: this.form.identitas_pemegang_kkprl.nomor,
          tanggal_penerbitan_1: this.form.identitas_pemegang_kkprl.tgl_penerbitan,
          nama_pemegang_1: this.form.identitas_pemegang_kkprl.nama_pemegang,
          npwp_1: this.form.identitas_pemegang_kkprl.npwp,
          alamat_kantor_1: this.form.identitas_pemegang_kkprl.alamat_kantor,
          no_telepon_1: this.form.identitas_pemegang_kkprl.no_telepon,
          email_1: this.form.identitas_pemegang_kkprl.surat_elektronik,
          status_penanaman_modal_1: this.form.identitas_pemegang_kkprl.status_penanaman_modal,
          keterangan_1: this.form.identitas_pemegang_kkprl.keterangan,
          nama_2: this.form.identitas_penanggung_jawab.nama_penanggung_jawab,
          jabatan_2: this.form.identitas_penanggung_jawab.jabatan_penanggung_jawab,
          no_telepon_2: this.form.identitas_penanggung_jawab.nomor_telepon,
          email_2: this.form.identitas_penanggung_jawab.surat_elektronik,
          keterangan_2: this.form.identitas_penanggung_jawab.keterangan,
          status_perizinan_lingkungan_3: this.form.kemajuan_perizinan_yang_diperoleh.status_persetujuan_lingkungan,
          bukti_mengurus_perizinan_lingkungan_3: this.form.kemajuan_perizinan_yang_diperoleh.bukti_sedang_mengurus_persetujuan_lingkungan,
          status_perizinan_berusaha_nonberusaha_3: this.form.kemajuan_perizinan_yang_diperoleh.status_perizinan_berusaha_nonberusaha,
          bukti_mengurus_perizinan_berusaha_nonberusaha_3: this.form.kemajuan_perizinan_yang_diperoleh.bukti_sedang_mengurus_perizinan_berusaha_nonberusaha,
          keterangan_3: this.form.kemajuan_perizinan_yang_diperoleh.keterangan,
          luas_panjang_4: this.form.realisasi_pemanfaatan_ruang_laut.luas_panjang,
          lokasi_kegiatan_4: this.form.realisasi_pemanfaatan_ruang_laut.lokasi_kegiatan,
          kode_kbli_4: this.form.realisasi_pemanfaatan_ruang_laut.kode_kbli,
          kegiatan_4: this.form.realisasi_pemanfaatan_ruang_laut.kegiatan,
          detail_kegiatan_4: this.form.realisasi_pemanfaatan_ruang_laut.detail_kegiatan,
          dokumentasi_kegiatan_4: this.form.realisasi_pemanfaatan_ruang_laut.dokumentasi_kegiatan,
          waktu_kegiatan_4: this.form.realisasi_pemanfaatan_ruang_laut.waktu_realisasi_kegiatan,
          keterangan_4: this.form.realisasi_pemanfaatan_ruang_laut.keterangan,
          keberlanjutan_kehidupan_5: this.form.pemenuhan_kewajiban[0].nilai,
          keterangan_keberlanjutan_kehidupan_5: this.form.pemenuhan_kewajiban[0].keterangan,
          akses_nelayan_5: this.form.pemenuhan_kewajiban[1].nilai,
          keterangan_akses_nelayan_5: this.form.pemenuhan_kewajiban[1].keterangan,
          kepentingan_5: this.form.pemenuhan_kewajiban[2].nilai,
          keterangan_kepentingan_5: this.form.pemenuhan_kewajiban[2].keterangan,
          ramah_lingkungan_5: this.form.pemenuhan_kewajiban[3].nilai,
          keterangan_ramah_lingkungan_5: this.form.pemenuhan_kewajiban[3].keterangan,
          kelestarian_5: this.form.pemenuhan_kewajiban[4].nilai,
          keterangan_kelestarian_5: this.form.pemenuhan_kewajiban[4].keterangan,
          kehidupan_migrasi_5: this.form.pemenuhan_kewajiban[5].nilai,
          keterangan_kehidupan_migrasi_5: this.form.pemenuhan_kewajiban[5].keterangan,
          akses_darurat_5: this.form.pemenuhan_kewajiban[6].nilai,
          keterangan_akses_darurat_5: this.form.pemenuhan_kewajiban[6].keterangan,
          memberdayakan_masyarakat_5: this.form.pemenuhan_kewajiban[7].nilai,
          keterangan_memberdayakan_masyarakat_5: this.form.pemenuhan_kewajiban[7].keterangan,
          membongkar_5: this.form.pemenuhan_kewajiban[8].nilai,
          keterangan_membongkar_5: this.form.pemenuhan_kewajiban[8].keterangan,
          tidak_konflik_5: this.form.pemenuhan_kewajiban[9].nilai,
          keterangan_tidak_konflik_5: this.form.pemenuhan_kewajiban[9].keterangan,
          tidak_ganggu_5: this.form.pemenuhan_kewajiban[10].nilai,
          keterangan_tidak_ganggu_5: this.form.pemenuhan_kewajiban[10].keterangan,
          laporan_perolehan_5: this.form.pemenuhan_kewajiban[11].nilai,
          keterangan_laporan_perolehan_5: this.form.pemenuhan_kewajiban[11].keterangan,
          laporan_rutin_5: this.form.pemenuhan_kewajiban[12].nilai,
          keterangan_laporan_rutin_5: this.form.pemenuhan_kewajiban[12].keterangan,
          bermitra_5: this.form.pemenuhan_kewajiban[13].nilai,
          keterangan_bermitra_5: this.form.pemenuhan_kewajiban[13].keterangan,
          melaporkan_hidrografi_oseanografi_5: this.form.pemenuhan_kewajiban[14].nilai,
          keterangan_melaporkan_hidrografi_oseanografi_5: this.form.pemenuhan_kewajiban[14].keterangan,
          sarana_prasarana_5: this.form.pemenuhan_kewajiban[15].nilai,
          keterangan_sarana_prasarana_5: this.form.pemenuhan_kewajiban[15].keterangan,
          total_identitas_pemegang_kkprl:this.form.total_identitas_pemegang_kkprl,
          total_identitas_penanggung_jawab:this.form.total_identitas_penanggung_jawab,
          total_kemajuan_perizinan_yang_diperoleh:this.form.total_kemajuan_perizinan_yang_diperoleh,
          total_realisasi_pemanfaatan_ruang_laut:this.form.total_realisasi_pemanfaatan_ruang_laut,
          total_pemenuhan_kewajiban:this.form.total_pemenuhan_kewajiban,
          total_skor: this.form.total_skor,
          nilai: this.form.nilai,
          kategori: this.form.kategori,
          status_penyampaian: this.form.status_penyampaian,
          jumlah_hari_keterlambatan: this.form.status_penyampaian === 'Telat' ? parseFloat(this.form.jumlah_hari_keterlambatan) : undefined,
          masa_berlaku: this.form.masa_berlaku,
          rekomendasi_penilaian_kkprl: this.form.rekomendasi_penilaian_kkprl,
          catatan: this.form.catatan,
        }

      const formData = {}
      for (const d in dataPenilaian) {
        if (dataPenilaian[d] != null && dataPenilaian[d] !== '') formData[d] = dataPenilaian[d]
      }

      if (this.jenis_masa_berlaku === 'Diketahui') {
        formData.masa_berlaku = this.form.masa_berlaku
      } else {
        formData.masa_berlaku = null
      }

      if (!this.$route.query.id_penilaian) {
        // create penilaian
        return axios
          .post(this.baseapiPengendalian + 'api/penilaian_laporan', formData, this.getApiOption())
          .then((res) => {
            Swal.fire('Berhasil', 'Penilaian Laporan Tahunan tersimpan sebagai draf', 'success')
            this.$router.replace({
              path: this.$route.path,
              query: {
                id_laporan: this.$route.query.id_laporan,
                id_penilaian: res.data.data.id,
              },
            })
            return true
          })
          .catch((err) => {
            Swal.fire('Gagal', 'Terjadi kesalahan', 'error')
            return false
          })
          .finally(() => {
            this.$loading(false)
          })
      } else {
        // update penilaian
        dataPenilaian.id_laporan = undefined
        return axios
          .put(
            this.baseapiPengendalian + `api/penilaian_laporan/${this.$route.query.id_penilaian}`,
            formData,
            this.getApiOption(),
          )
          .then((res) => {
            Swal.fire('Berhasil', 'Penilaian Laporan Tahunan tersimpan sebagai draf', 'success')
            return true
          })
          .catch((err) => {
            Swal.fire('Gagal', 'Terjadi kesalahan', 'error')
            return false
          })
          .finally(() => {
            this.$loading(false)
          })
      }
    },

    addFormError(fieldName) {
      this.errors.add({
        field: fieldName,
        msg: `${fieldName} wajib diisi`,
      })
    },

    removeFormError(fieldName) {
      this.errors.remove(fieldName)
    },

    calculateTotalScore() {
      let total_identitas_pemegang_kkprl = 0
      for (let key in this.form.identitas_pemegang_kkprl) {
        if (key != 'keterangan' && this.form.identitas_pemegang_kkprl[key]) {
          total_identitas_pemegang_kkprl += 0.5
        }
      }

      let total_identitas_penanggung_jawab = 0
      for (let key in this.form.identitas_penanggung_jawab) {
        if (key != 'keterangan' && this.form.identitas_penanggung_jawab[key]) {
          total_identitas_penanggung_jawab += 1
        }
      }

      let total_kemajuan_perizinan_yang_diperoleh = 0
      // prettier-ignore
      {
        if (this.form.kemajuan_perizinan_yang_diperoleh.status_persetujuan_lingkungan) {
          total_kemajuan_perizinan_yang_diperoleh += parseInt(this.form.kemajuan_perizinan_yang_diperoleh.status_persetujuan_lingkungan)
        }
        if (this.form.kemajuan_perizinan_yang_diperoleh.bukti_sedang_mengurus_persetujuan_lingkungan) {
          total_kemajuan_perizinan_yang_diperoleh += 2
        }
        if (this.form.kemajuan_perizinan_yang_diperoleh.status_perizinan_berusaha_nonberusaha) {
          total_kemajuan_perizinan_yang_diperoleh += parseInt(this.form.kemajuan_perizinan_yang_diperoleh.status_perizinan_berusaha_nonberusaha)
        }
        if (this.form.kemajuan_perizinan_yang_diperoleh.bukti_sedang_mengurus_perizinan_berusaha_nonberusaha) {
          total_kemajuan_perizinan_yang_diperoleh += 2
        }
      }

      let total_realisasi_pemanfaatan_ruang_laut = 0
      for (let key in this.form.realisasi_pemanfaatan_ruang_laut) {
        if (key != 'keterangan' && this.form.realisasi_pemanfaatan_ruang_laut[key]) {
          total_realisasi_pemanfaatan_ruang_laut += 2
        }
      }

      let total_pemenuhan_kewajiban = 0
      for (let item of this.form.pemenuhan_kewajiban) {
        if (item.nilai) {
          total_pemenuhan_kewajiban += parseInt(item.nilai)
        }
      }

      let totalScore =
        total_identitas_pemegang_kkprl +
        total_identitas_penanggung_jawab +
        total_kemajuan_perizinan_yang_diperoleh +
        total_realisasi_pemanfaatan_ruang_laut +
        total_pemenuhan_kewajiban

      this.form.total_identitas_pemegang_kkprl = total_identitas_pemegang_kkprl
      this.form.total_identitas_penanggung_jawab = total_identitas_penanggung_jawab
      this.form.total_kemajuan_perizinan_yang_diperoleh = total_kemajuan_perizinan_yang_diperoleh
      this.form.total_realisasi_pemanfaatan_ruang_laut = total_realisasi_pemanfaatan_ruang_laut
      this.form.total_pemenuhan_kewajiban = total_pemenuhan_kewajiban
      totalScore = Math.round(totalScore)
      this.form.total_skor = totalScore
      if (totalScore >= 81 && totalScore <= 100) {
        this.form.nilai = 'A'
        this.form.kategori = 'Sangat Baik'
      } else if (totalScore >= 66 && totalScore <= 80) {
        this.form.nilai = 'B'
        this.form.kategori = 'Baik'
      } else if (totalScore >= 51 && totalScore <= 65) {
        this.form.nilai = 'C'
        this.form.kategori = 'Cukup'
      } else if (totalScore >= 36 && totalScore <= 50) {
        this.form.nilai = 'D'
        this.form.kategori = 'Kurang'
      } else {
        this.form.nilai = 'E'
        this.form.kategori = 'Sangat Kurang'
      }
    },

    loadDataLaporanTahunan() {
      axios
        .get(this.baseapiPengendalian + 'api/laporan_tahunan/' + this.$route.query.id_laporan, this.getApiOption())
        .then((res) => {
          const data = res.data.data
          this.selectedLaporan = data
          this.jenis_kegiatan = data.jenis_kegiatan
          this.form = {
            ...this.form,
            tim_penilai: data.nama_penilai,
            nomor_kkprl: data.nomor_kkprl,
            alamat_kantor: data.alamat_kantor,
            no_telepon: data.no_telepon,
            surat_elektronik: data.email,
            status_penanaman_modal: data.status_penanaman_modal,
            luas: data.realisasi_luas,
            panjang: data.realisasi_panjang,
            lokasi: data.provinsi,
            nama_perairan: data.nama_perairan,
            tgl_penerbitan_kkprl: formatDate(data.tanggal_penerbitan, 'DD/MM/YYYY'),
            tgl_disampaikan_laporan_tahunan: formatDate(data.tanggal_submit_laporan, 'DD/MM/YYYY'),
          }

          if (this.jenis_kegiatan === 'Non Berusaha') {
            this.form.realisasi_pemanfaatan_ruang_laut.kode_kbli = true
          }

          const terbit = new Date(data.tanggal_penerbitan)
          terbit.setFullYear(Number(data.tahun_laporan))
          terbit.setHours(0, 0, 0, 0)
          const lapor = new Date(data.tanggal_submit_laporan)
          lapor.setHours(0, 0, 0, 0)

          const telat = Math.floor((lapor - terbit) / (1000 * 60 * 60 * 24))

          if (lapor >= terbit) {
            this.form.status_penyampaian = 'Telat'
            this.form.jumlah_hari_keterlambatan = telat + 1
          } else {
            this.form.status_penyampaian = 'Tidak Telat'
            this.form.jumlah_hari_keterlambatan = 0
          }
        })
        .catch((err) => {
          Swal.fire('Gagal', 'Terjadi kesalahan saat mengambil data Laporan Tahunan', 'error')
        })
    },

    loadDataPenilaian() {
      if (this.$route.path.includes('tinjau')) {
        this.sudah_dinilai = true
      }

      if (!this.$route.query.id_penilaian) {
        return
      }

      axios
        .get(
          this.baseapiPengendalian + `api/penilaian_laporan?filter=id_laporan,=,${this.$route.query.id_laporan}`,
          this.getApiOption(),
        )
        .then((res) => {
          const data = res.data.data[0]

          if (!data) {
            return
          }

          setTimeout(() => {
            if (dayjs(data.masa_berlaku).isValid()) {
              this.jenis_masa_berlaku = 'Diketahui'
            } else {
              this.jenis_masa_berlaku = 'Selama Menjalankan Kegiatan Usaha'
            }
          }, 300)

          if (data.status === 'Selesai') {
            this.sudah_dinilai = true
          }

          this.id_penilaian = data.id
          this.form = {
            ...this.form,
            tgl_penilaian: data.tanggal_penilaian,
            identitas_pemegang_kkprl: {
              nomor: data.nomor_1,
              tgl_penerbitan: data.tanggal_penerbitan_1,
              nama_pemegang: data.nama_pemegang_1,
              npwp: data.npwp_1,
              alamat_kantor: data.alamat_kantor_1,
              no_telepon: data.no_telepon_1,
              surat_elektronik: data.email_1,
              status_penanaman_modal: data.status_penanaman_modal_1,
              keterangan: data.keterangan_1,
            },
            identitas_penanggung_jawab: {
              nama_penanggung_jawab: data.nama_2,
              jabatan_penanggung_jawab: data.jabatan_2,
              nomor_telepon: data.no_telepon_2,
              surat_elektronik: data.email_2,
              keterangan: data.keterangan_2,
            },
            kemajuan_perizinan_yang_diperoleh: {
              status_persetujuan_lingkungan: data.status_perizinan_lingkungan_3,
              bukti_sedang_mengurus_persetujuan_lingkungan: data.bukti_mengurus_perizinan_lingkungan_3,
              status_perizinan_berusaha_nonberusaha: data.status_perizinan_berusaha_nonberusaha_3,
              bukti_sedang_mengurus_perizinan_berusaha_nonberusaha:
                data.bukti_mengurus_perizinan_berusaha_nonberusaha_3,
              keterangan: data.keterangan_3,
            },
            realisasi_pemanfaatan_ruang_laut: {
              luas_panjang: data.luas_panjang_4,
              lokasi_kegiatan: data.lokasi_kegiatan_4,
              kode_kbli: data.kode_kbli_4,
              kegiatan: data.kegiatan_4,
              detail_kegiatan: data.detail_kegiatan_4,
              dokumentasi_kegiatan: data.dokumentasi_kegiatan_4,
              waktu_realisasi_kegiatan: data.waktu_kegiatan_4,
              keterangan: data.keterangan_4,
            },
            pemenuhan_kewajiban: [
              {
                // a
                nilai: data.keberlanjutan_kehidupan_5,
                keterangan: data.keterangan_keberlanjutan_kehidupan_5,
              },
              {
                //b
                nilai: data.akses_nelayan_5,
                keterangan: data.keterangan_akses_nelayan_5,
              },
              {
                //c
                nilai: data.kepentingan_5,
                keterangan: data.keterangan_kepentingan_5,
              },
              {
                //d
                nilai: data.ramah_lingkungan_5,
                keterangan: data.keterangan_ramah_lingkungan_5,
              },
              {
                //e
                nilai: data.kelestarian_5,
                keterangan: data.keterangan_kelestarian_5,
              },
              {
                //f
                nilai: data.kehidupan_migrasi_5,
                keterangan: data.keterangan_kehidupan_migrasi_5,
              },
              {
                //g
                nilai: data.akses_darurat_5,
                keterangan: data.keterangan_akses_darurat_5,
              },
              {
                //h
                nilai: data.memberdayakan_masyarakat_5,
                keterangan: data.keterangan_memberdayakan_masyarakat_5,
              },
              {
                //i
                nilai: data.membongkar_5,
                keterangan: data.keterangan_membongkar_5,
              },
              {
                //j
                nilai: data.tidak_konflik_5,
                keterangan: data.keterangan_tidak_konflik_5,
              },
              {
                //k
                nilai: data.tidak_ganggu_5,
                keterangan: data.keterangan_tidak_ganggu_5,
              },
              {
                //l
                nilai: data.laporan_perolehan_5,
                keterangan: data.keterangan_laporan_perolehan_5,
              },
              {
                //m
                nilai: data.laporan_rutin_5,
                keterangan: data.keterangan_laporan_rutin_5,
              },
              {
                //n
                nilai: data.bermitra_5,
                keterangan: data.keterangan_bermitra_5,
              },
              {
                //o
                nilai: data.melaporkan_hidrografi_oseanografi_5,
                keterangan: data.keterangan_melaporkan_hidrografi_oseanografi_5,
              },
              {
                //p
                nilai: data.sarana_prasarana_5,
                keterangan: data.keterangan_sarana_prasarana_5,
              },
            ],
            masa_berlaku: data.masa_berlaku,
            rekomendasi_penilaian_kkprl: data.rekomendasi_penilaian_kkprl,
            // nomor_berita_acara: data.nomor_berita_acara,
            // nomor_sertifikat: data.nomor_sertifikat,
            catatan: data.catatan || '',
          }
          this.tgl_penilaian = data.tanggal_penilaian ? formatDate(data.tanggal_penilaian, 'DD/MM/YYYY') : 'dd/mm/yyyy'
        })
        .catch((err) => {
          Swal.fire('Gagal', 'Terjadi kesalahan saat mengambil data Penilaian Laporan Tahunan', 'error')
        })
    },

    toggleModalChat() {
      this.$bvModal.show('modal-chat')
    },

    getProvinsi() {
      axios.get(this.baseapiPengendalian + 'api/provinsi?sort=id,ASC', this.getApiOption()).then((response) => {
        this.dataProvinsi = response.data.data
      })
    },

    getApiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      }
    },
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.calculateTotalScore()

        function buatKeterangan(a, b, n, jenis = '') {
          let s = ''
          if (a.length === 0) {
            s = 'Mencantumkan semua'
          } else if (a.length === n) {
            s = 'Tidak mencantumkan semua'
          } else {
            s = 'Tidak mencantumkan'
            for (const [i, x] of a.entries()) {
              if (a.length > 2 && i !== 0) s += ','
              if (a.length > 1 && i === a.length - 1) s += ' dan'
              s += ` ${x}`
            }
          }
          if (jenis === 'Non Berusaha') {
            s += '. Kegiatan non berusaha tidak memerlukan kode KBLI'
          }
          b.keterangan = s
        }

        const keterangan_identitas_pemegang_kkprl = []
        if (!this.form.identitas_pemegang_kkprl.nomor) {
          keterangan_identitas_pemegang_kkprl.push('Nomor')
        }
        if (!this.form.identitas_pemegang_kkprl.tgl_penerbitan) {
          keterangan_identitas_pemegang_kkprl.push('tanggal penerbitan')
        }
        if (!this.form.identitas_pemegang_kkprl.nama_pemegang) {
          keterangan_identitas_pemegang_kkprl.push('nama pemegang')
        }
        if (!this.form.identitas_pemegang_kkprl.npwp) {
          keterangan_identitas_pemegang_kkprl.push('NPWP')
        }
        if (!this.form.identitas_pemegang_kkprl.alamat_kantor) {
          keterangan_identitas_pemegang_kkprl.push('alamat kantor')
        }
        if (!this.form.identitas_pemegang_kkprl.no_telepon) {
          keterangan_identitas_pemegang_kkprl.push('nomor telepon')
        }
        if (!this.form.identitas_pemegang_kkprl.surat_elektronik) {
          keterangan_identitas_pemegang_kkprl.push('surat elektronik/faksimili')
        }
        if (!this.form.identitas_pemegang_kkprl.status_penanaman_modal) {
          keterangan_identitas_pemegang_kkprl.push('status penanaman modal')
        }
        buatKeterangan(keterangan_identitas_pemegang_kkprl, this.form.identitas_pemegang_kkprl, 8)

        const keterangan_identitas_penanggung_jawab = []
        if (!this.form.identitas_penanggung_jawab.nama_penanggung_jawab) {
          keterangan_identitas_penanggung_jawab.push('nama penanggung jawab')
        }
        if (!this.form.identitas_penanggung_jawab.jabatan_penanggung_jawab) {
          keterangan_identitas_penanggung_jawab.push('jabatan penanggung jawab')
        }
        if (!this.form.identitas_penanggung_jawab.nomor_telepon) {
          keterangan_identitas_penanggung_jawab.push('nomor telepon')
        }
        if (!this.form.identitas_penanggung_jawab.surat_elektronik) {
          keterangan_identitas_penanggung_jawab.push('surat elektronik')
        }
        buatKeterangan(keterangan_identitas_penanggung_jawab, this.form.identitas_penanggung_jawab, 4)

        const keterangan_kemajuan_perizinan = []
        if (!this.form.kemajuan_perizinan_yang_diperoleh.bukti_sedang_mengurus_persetujuan_lingkungan) {
          keterangan_kemajuan_perizinan.push('bukti mengurus persetujuan lingkungan')
        }
        if (!this.form.kemajuan_perizinan_yang_diperoleh.bukti_sedang_mengurus_perizinan_berusaha_nonberusaha) {
          keterangan_kemajuan_perizinan.push('bukti mengurus perizinan berusaha/non berusaha')
        }
        buatKeterangan(keterangan_kemajuan_perizinan, this.form.kemajuan_perizinan_yang_diperoleh, 2)

        const keterangan_realisasi = []
        if (!this.form.realisasi_pemanfaatan_ruang_laut.luas_panjang) {
          keterangan_realisasi.push('luas/panjang')
        }
        if (!this.form.realisasi_pemanfaatan_ruang_laut.lokasi_kegiatan) {
          keterangan_realisasi.push('lokasi kegiatan')
        }
        if (!this.form.realisasi_pemanfaatan_ruang_laut.kode_kbli) {
          keterangan_realisasi.push('kode KBLI')
        }
        if (!this.form.realisasi_pemanfaatan_ruang_laut.kegiatan) {
          keterangan_realisasi.push('jenis kegiatan')
        }
        if (!this.form.realisasi_pemanfaatan_ruang_laut.detail_kegiatan) {
          keterangan_realisasi.push('detail kegiatan')
        }
        if (!this.form.realisasi_pemanfaatan_ruang_laut.dokumentasi_kegiatan) {
          keterangan_realisasi.push('dokumentasi kegiatan')
        }
        if (!this.form.realisasi_pemanfaatan_ruang_laut.waktu_realisasi_kegiatan) {
          keterangan_realisasi.push('waktu realisasi kegiatan')
        }
        buatKeterangan(keterangan_realisasi, this.form.realisasi_pemanfaatan_ruang_laut, 7, this.jenis_kegiatan)
      },
    },
  },
}
</script>
